import { trapFocusFilter } from "../helpers/trapFocusFilter"

const filtersButton = document.querySelector(".filters-button")
const closeFiltersButton = document.querySelector(".close-filters-button")
const filters = document.querySelector(".filters")
const mdcTagFilter = document.querySelector(".js-mdc-tag-filter")
const body = document.body
const html = document.documentElement


if (filters) {
    filtersButton.addEventListener("click", function () {
        if (this.getAttribute("aria-expanded") === "false") {
            trapFocusFilter();
            const scrollY = document.documentElement.style.getPropertyValue("--scroll-y")
            this.setAttribute("aria-expanded", "true")
            html.classList.add("filters-open")
            body.style.top = `-${scrollY}`

            // Move focus to first focusable element in filters panel
            setTimeout(() => {
                const firstFocusable = filters.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
                if (firstFocusable) {
                    firstFocusable.focus()
                }
            }, 100)
        } else {
            const scrollY = body.style.top
            this.setAttribute("aria-expanded", "false")
            html.classList.remove("filters-open")
            body.style.top = ""
            window.scrollTo(0, parseInt(scrollY || "0") * -1)

            // Return focus to the filters button
            this.focus()
        }
    })

    closeFiltersButton.addEventListener("click", function () {
        html.classList.remove("filters-open")
        filtersButton.setAttribute("aria-expanded", "false")

        // Return focus to the filters button when closing
        filtersButton.focus()
    })
}


if (mdcTagFilter) {
    const mdcFilterParent = mdcTagFilter.closest(".nx-accordion__content")
    const mdcTags = mdcFilterParent.querySelectorAll('input[type="checkbox"]')
    mdcTagFilter.addEventListener("input", () => {
        const query = mdcTagFilter.value
        let filteredMdcTags = [...mdcTags]

        if (query !== "") {
            filteredMdcTags.forEach((tag) => {
                const parent = tag.parentElement
                if (!tag.value.toLowerCase().includes(query.toLowerCase())) {
                    parent.style.display = "none"
                } else {
                    parent.removeAttribute("style")
                }
            })
        } else {
            filteredMdcTags.forEach((tag) => {
                const parent = tag.parentElement
                parent.removeAttribute("style")
            })
        }
    })
}
